import React from 'react';
import styled from 'styled-components';
import {
  ContentfulAsset,
  JumpLinkHeroModule as FMJumpLinkHeroModule,
} from '@spotify-internal/frodor-modules';
import { ModuleType } from './types';
import {
  screenMdMin,
  screenSmMax,
  spacer8,
} from '@spotify-internal/encore-web';

const JLWrapper = styled.div<{
  backgroundColor?: string;
  textColor?: string;
}>`
  // here and below are specific to frodor, not needed in storybook
  background: ${({ backgroundColor }) => backgroundColor};
  padding-top: 76px;
  @media (min-width: ${screenMdMin}) {
    & svg {
      box-sizing: unset;
      padding-top: ${spacer8};
    }
    a > div > div {
      padding-bottom: 12px;
    }
  }

  @media (max-width: ${screenSmMax}) {
    padding-top: 56px;
  }
`;

type JumpLinkType = ModuleType & {
  headline: string;
  title: string;
  svgIcon?: string;
  colors: any;
  hoverBackground: string;
  eyebrowText?: string;
  supertext?: string;
};

type Colors = {
  theme: string;
  iconColor?: string;
};

export type JumpLinkHeroModuleType = ModuleType & {
  headline: string;
  isTagline: boolean;
  tagline?: string;
  paragraph?: string;
  image?: ContentfulAsset;
  backgroundColor?: string;
  textColor?: string;
  layout?: string;
  btnComponent?: React.FC;
  jumpLinks: JumpLinkType[];
  modulePrimaryColors: Colors;
  moduleHoverColors: Colors;
  eyebrowOrHeadline: boolean;
  eyebrowText?: string;
  supertext?: string;
};

export const JumpLinkHeroModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  JumpLinkHeroModuleType
>((props, ref) => {
  return (
    <JLWrapper
      backgroundColor={
        props.modulePrimaryColors.theme === 'dark' ? '#000000' : '#FFFFFF'
      }
    >
      <FMJumpLinkHeroModule {...props} ref={ref} />
    </JLWrapper>
  );
});
